@if (selectedSites.length > 0) {
  <pp-bulk-changes-bar
    [ppSelectedNumber]="selectedSites.length"
    [ppSelectedTextKey]="'sites_selected'"
    (ppClose)="deselectAll()"
    >
    @if (allUnarchived) {
      <pp-bulk-changes-button
        [ppIconPath]="EIconPath.ICON_MISC_ARCHIVE_24"
        [ppText]="'archive' | ppTranslate"
        (ppAction)="showArchiveSitesModal()"
      ></pp-bulk-changes-button>
    }
    @if (allArchived) {
      <pp-bulk-changes-button
        [ppIconPath]="EIconPath.ICON_MISC_ARCHIVE_24"
        [ppText]="'unarchive' | ppTranslate"
        (ppAction)="showUnarchiveSitesModal()"
      ></pp-bulk-changes-button>
    }
    @if (!allArchived && !allUnarchived) {
      <pp-bulk-changes-button
        [ppIconPath]="EIconPath.ICON_MISC_ARCHIVE_24"
        [ppText]="'archive' | ppTranslate"
        [ppDisabled]="true"
      ></pp-bulk-changes-button>
    }
  </pp-bulk-changes-bar>
}
